<script lang="ts" setup>
import { onMounted, reactive, ref } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  loadStichtagfromConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";
import AUApi from "@/api";
import { Globals } from "@/Globals";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { getDisplay } from "@/DataHelper";
import EditComboBoxItem from "@/editor/EditComboBoxItem.vue";
import { onShowSite } from "@/NavigationHelper";
import { showDialog } from "@/UIHelper";
// import { VTreeview } from "vuetify/labs/VTreeview";
import {
  globalsBezeichnung,
  globalsStt,
  globalsAic,
  globalsBegriffCache,
  checkBegriff,
} from "@/local";
import {
  EditComboboxControlProps,
  EditComboboxItemData,
  EditComboBoxItemUiData,
  EditComboBoxUiData,
  iconNoFav,
} from "./EditComboboxFunctions";
import { useRegisterValidation } from "@/components/EditorValidator";
const emitFn = defineEmits<CommonEditControlEmits>();

// eigene props deklarieren können
// eigene config machen
declare interface EditComboboxControlConfig extends EditorControlConfig {
  zeitbereich?: APIZeitbereich;
}

const props = defineProps<EditComboboxControlProps>();
const { config, ui } = getDefaultEditorControlConfig<
  EditComboboxControlConfig,
  EditComboboxControlProps,
  EditComboBoxUiData
>(props, emitFn);
const uiData = reactive(ui);
config.validate = validate;
useRegisterValidation({ config });

export declare interface TreeItem extends EditComboboxItemData {
  bezeichnung?: string;
  aic?: number;
  stt?: string;
  sttBez?: string;
  children?: TreeItemChild[];
  vonVA?: Date;
}
declare interface TreeItemChild {
  aic: number;
  bezeichnung: string;
  stt: number;
  sttBez: string;
}

let stt!: number;

let fields: object = {
  dataSource: uiData.items,
  value: "aic",
  text: "bezeichnung",
  child: "children",
};

let showList = ref<boolean>(false);
let list: EditComboboxItemData[] = [];

let selectedElement: any = {
  aic: null,
  bezeichnung: globalsBezeichnung(Globals.Begriff, "Web_Bitte_waehlen", "Bitte wählen"),
  stt: "",
  sttBez: "",
};
let field: any = config.querycolumn;

let sysAbfrage: any = null;
let selectedText: string = "";
let menuwith: string = "80%";
let initialized: boolean = false;
let activatable: boolean = true;
let rawlist: EditComboboxItemData[] = [];
let search: string = "";

onMounted(async () => {
  try {
    if (props.queryZeitbereich) {
      config.zeitbereich = props.queryZeitbereich;
    }
    if (!field && config.column) {
      field = config.column;
    }
    mounted(uiData, props, config);

    if (props.sttVon && props.sttBis) {
      const aicSttVon = props.sttVon;
      const aicSttBis = props.sttBis;
      AUApi.Current.getStammtyp(
        (data: any) => dataLoadedHierarchie(data),
        aicSttVon,
        null,
        false,
        props.aicRolle
      );
      initialized = true;
    } else if (field && field.type === "hierarchie") {
      const aicEig = field.aicEig;
      const aicSttVon = field.meta.Stt;
      stt = aicSttVon;
      const begr = globalsStt(Globals.Begriff, stt, "", true);
      if (begr) {
        sysAbfrage = begr.kennung;
        uiData.showSettings = true;
      }
      const aicSttBis = uiData.stammtyp ?? 0;
      AUApi.Current.getHierarchie(
        (data: any) => dataLoadedHierarchie(data),
        aicEig,
        aicSttVon,
        aicSttBis,
        props.aicRolle ?? 0,
        null,
        false
      );
    } else {
      let name = "" + uiData.kennung;
      if (field) {
        name += " " + field.bezeichnung;
      }
      console.log("EditHierarchie: no data and config for " + name);
      initialized = true;
    }
  } catch (err) {
    console.log(err);
  }
});
function filter(depth: number = 0) {
  const searchLocal = search.toLowerCase();
  const y = uiData.items.find((x: any) => {
    if (x.bezeichnung === searchLocal) {
      return true;
    }
    if (x.children && depth < 100) {
      const find: any = findMe(search, x.children, depth + 1);
      if (find) {
        return true;
      }
    }
  });
}
function filterFunction(item: any, queryText: string, itemText: string): boolean {
  queryText = queryText.toLowerCase();
  if (item.headerHtml) {
    return true;
  }
  if (
    (itemText && itemText.toLowerCase && itemText.toLowerCase() + "").startsWith(
      queryText
    )
  ) {
    return true;
  }
  if (item.rowData) {
    const x = item.rowData.find(
      (t: string) => t && t.toLowerCase && (t.toLowerCase() + "").startsWith(queryText)
    );
    if (x) {
      return true;
    }
  }
  return false;
}

function dataLoadedHierarchie(data: any) {
  try {
    if (props.sttVon) {
      list = data.data.data;
      const columns = data.data.columns;
      if (columns) {
        setColumns(columns);
      }
    } else {
      uiData.items = data.data.data;
    }
    data = getInitValue();
    if (data) {
      const element = data;
      // list.push(element);
      list = uiData.items;
      uiData.selected = element;
      stt = element.stt;
      const begr = globalsStt(Globals.Begriff, stt, "", true);
      if (begr) {
        sysAbfrage = begr.kennung;
        uiData.showSettings = true;
      }
      if (element.bezeichnung) {
        uiData.hintText = element.bezeichnung + ", " + element.sttBez;
      }
      if (props.initStichtag) {
        uiData.showStichtag = true;
        uiData.hintText = uiData.hintText + ", ab: " + props.initStichtag;
      }
      selectedText = element.bezeichnung;
      selectedElement = element;
      config.emit("input", uiData.selected);
    } else if (!props.sttVon) {
      list = uiData.items;
    }
    // config.emit("loaded", uiData.items);
    if (!selectedText) {
      selectedText = "bitte auswählen";
    }
    if (props.selectedItem) {
      selectedValueChanged(props.selectedItem, true);
    }
    initialized = true;
    uiData.showLoading = false;
    return;
  } catch (err) {
    console.log(err);
    initialized = true;
    uiData.showLoading = false;
  }
  // config.emit("loaded", uiData.items);
  if (!selectedText) {
    selectedText = "bitte auswählen";
  }
}
function selectedValueChanged(data: any, ausInit?: boolean) {
  const isMobile = Capacitor.getPlatform() !== "web";
  if (isMobile) {
    Keyboard.hide();
  }

  let comboVal: any;
  if (props.sttVon) {
    comboVal = data;
  } else {
    comboVal = data[0];
  }
  if (props.sttVon && !list) {
    return;
  } else if (!props.sttVon && (!uiData.items || uiData.items.length === 0)) {
    return;
  }
  let findSelect;
  if (typeof comboVal === "number" && uiData.items) {
    findSelect = findMe(comboVal.toString(), uiData.items, 0);
  } else if (typeof comboVal === "string") {
    findSelect = findMe(comboVal, uiData.items, 0);
  } else if (comboVal && comboVal.aic) {
    findSelect = comboVal;
  } else {
    findSelect = [];
  }
  if (findSelect) {
    uiData.selected = findSelect;
    selectedText = findSelect.bezeichnung;
    selectedElement = findSelect;
    if (props.sttVon) {
      list.push(findSelect);
    } else {
      list = [];
      list.push(findSelect);
      const begr = globalsStt(Globals.Begriff, findSelect.stt, "", true);
      if (begr) {
        sysAbfrage = begr.kennung;
        uiData.showSettings = true;
      }
      if (findSelect.bezeichnung) {
        uiData.hintText = findSelect.bezeichnung + ", " + findSelect.sttBez;
      }
    }
    const val = uiData.selected;
    if (val == null || (val && val && (props.fireOnText || typeof val !== "string"))) {
      valueChanged(config, uiData, val, ausInit); // zum event triggern
      showList.value = false;
    }
  }
}
function findMe(searchterm: string, tosearch: TreeItem[], depth: number = 0) {
  const y = tosearch.find((x: any) => {
    if (x.aic === searchterm) {
      return x;
    }
    if (x.children && depth < 100) {
      const find: any = findMe(searchterm, x.children, depth + 1);
      if (find) {
        return find;
      }
    }
  });
  // return y;
}
function validate() {
  if (uiData.disabled) {
    uiData.errorText = "";
    return true;
  } // disabled Controls sind IMMER valide ;)
  if (uiData.required) {
    if (uiData.selected) {
      uiData.errorText = "";
      return true;
    }
    uiData.errorText = config.requiredMessage;
    return false;
  }
  uiData.errorText = "";
  return true;
}

function getInitValue(): any {
  // if (config.column && column.meta) {
  //   if (
  //     column.meta.neuArt === "Limit" ||
  //     column.meta.neuArt === "Last"
  //   ) {
  //     return config.initValue;
  //   }
  // }
  return config.initValue;
}
function loadStichtag() {
  loadStichtagfromConfig(config);
}

function openSettings() {
  const siteName = config.column!.title;
  if (props.openFromDialog) {
    showDialog({
      title: siteName,
      showTitle: true,
      site: "EditStamm",
      data: {
        query: sysAbfrage,
        aic: uiData.selected?.aic,
        showClose: false,
      },
      fullscreen: true,
      onClose: () => {
        return true;
      },
    });
  } else {
    onShowSite({
      title: siteName,
      site: "EditStamm",
      data: {
        query: sysAbfrage,
        aic: uiData.selected?.aic,
        showClose: false,
      },
      callOnLeave: () => {
        return true;
      },
    });
  }
}
function setColumns(columns: []) {
  const headerItem: any = {};
  const basePercent: number = 100;
  const visibleColumns: DataColumn[] = columns.filter(
    (c: any) => c.meta && !c.meta.invisible
  );
  let headerHtml = "<span class='ddHeader'>";
  let percent = "";
  const visibleColsWithWidthCount =
    visibleColumns.filter((col: any) => col.meta.webWidth)?.length ?? 0;
  const visibleColumnsLength = visibleColumns.length;

  if (visibleColumnsLength !== visibleColsWithWidthCount) {
    percent = (basePercent / (columns.length - visibleColsWithWidthCount)).toFixed(0);
  } else {
    percent = (basePercent / visibleColsWithWidthCount).toFixed(0);
  }
  for (let i = 0; i < visibleColumns.length; i++) {
    headerHtml +=
      "<span style='display: table-cell;width:" +
      percent +
      "%'>" +
      visibleColumns[i].title +
      "</span>";

    headerItem[visibleColumns[i].name] = {
      aic: -1,
      bezeichnung: visibleColumns[i].title,
    };
  }

  headerItem.headerHtml = headerHtml;
  let bezCol: any = columns.find((c: any) => c.kennung === props.textKennung);
  if (!bezCol) {
    bezCol = columns.find((c: any) => c.datatype === "Stringx");
  }
  const columnBez = bezCol?.name;

  const combo = list;
  if (combo.length > 0) {
    const mapped = combo.map((row: QueryDataRow): any => {
      const rowData = [] as QueryDataRow;
      for (let i = 0; i < visibleColumns.length; i++) {
        const column = visibleColumns[i];
        rowData.push(getDisplay(row, column));
      }
      return {
        aic: row.aic_Stamm,
        bezeichnung: row[columnBez],
        row,
        visibleColumns,
        percent,
        rowData,
      };
    });
    if (visibleColumns.length > 1) {
      mapped.unshift(headerItem);
    }
    rawlist = mapped;
    list = rawlist;
  }
}
</script>
<template>
  <div v-if="uiData.showMutable" class="wrap">
    <v-tooltip
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-row class="pa-0 ma-0" v-bind="props">
          <v-col cols="11" class="pa-0">
            <v-select
              v-bind="props"
              v-if="props.sttVon"
              :clearable="clearable"
              :label="uiData.description"
              :items="uiData.items"
              :disabled="uiData.disabled"
              ref="combobox"
              item-title="bezeichnung"
              item-value="aic"
              v-model="selectedElement"
              @change="selectedValueChanged"
              :loading="uiData.showLoading"
              :no-data-text="
                globalsBezeichnung(
                  Globals.Begriff,
                  'Web_keineDaten_gefunden',
                  'keine Daten gefunden'
                )
              "
              :filter="filterFunction"
              :error-messages="uiData.errorText"
              :hint="uiData.hintText"
              :append-icon="uiData.showStichtag ? 'mdi-history' : ''"
              @click:append="loadStichtag"
              :required="uiData.required"
              variant="outlined"
              density="compact"
              color="warning"
            >
              <template v-slot:item="{ props, internalItem }">
                <EditComboBoxItem
                  v-if="uiData.columns"
                  :columns="uiData.columns"
                  v-bind="props"
                  :style="'width:' + menuwith"
                  :item="internalItem.raw"
                />
              </template>
            </v-select>

            <v-select
              v-else
              v-bind="props"
              :clearable="clearable"
              :items="list"
              :label="uiData.description"
              :disabled="uiData.disabled"
              item-title="bezeichnung"
              item-value="aic"
              v-model="selectedElement"
              :loading="uiData.showLoading"
              :no-data-text="
                globalsBezeichnung(
                  Globals.Begriff,
                  'Web_keineDaten_gefunden',
                  'keine Daten gefunden'
                )
              "
              :error-messages="uiData.errorText"
              persistent-hint
              :hint="uiData.hintText"
              :append-icon="uiData.showStichtag ? 'mdi-history' : ''"
              @click:append="loadStichtag"
              :required="uiData.required"
              variant="outlined"
              density="compact"
              color="warning"
            >
              <template #item="{ props }">
                <v-card v-bind="props">
                  <v-text-field
                    v-if="!props.noSearch"
                    v-model="search"
                    label="Suche"
                    flat
                    dark
                    solo-inverted
                    hide-details
                    clearable
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>

                  <v-card-text class="pa-0">
                    <v-treeview
                      density="compact"
                      open-all
                      :items="uiData.items"
                      item-key="aic"
                      item-title="bezeichnung"
                      activatable
                      @update:active="selectedValueChanged"
                      return-object
                      :active="uiData.selected"
                      selected-color="success"
                      :multiple-active="false"
                      class="hierachieList"
                      :search="search"
                    >
                    </v-treeview>
                  </v-card-text>
                </v-card>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="1"
            class="pa-0"
            style="cursor: hand"
            v-if="props.showSettings"
            @click="openSettings"
          >
            <v-icon variant="text">mdi-dots-vertical</v-icon>
          </v-col>
        </v-row>
        <ValueChangeTracker v-if="uiData.isChanged || props.disableValueChangeTracker" />
      </template>
    </v-tooltip>
  </div>
</template>
<style scoped>
.v-icon {
  padding-top: 8px;
}
.v-card {
  margin: 0px;
  padding: 5px;
}
.v-list {
  padding: 0;
}
.v-list-item {
  padding: 0px 0px 0px 0px;
}
.hierachieList {
  overflow-y: scroll;
  max-height: 400px;
  padding: 0 0 0 0;
}
</style>
